  // src/pages/Products/index.jsx
  import React, { useEffect, useState } from "react";
  import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
  import { Star } from "lucide-react";
  import { useCart } from "../Context/Cartcontext";
  import ReviewSection from "../components/common/ReviewSection";
  import FlickThroughSection from "../components/common/FlickThroughSection";
  import PersonalisePanel from "../components/common/PersonalisePanel";

  import { getProductBySlug as getGhProduct,       getRelatedProducts as getGhRelated       } from "../data/giftHampers";
  import { getProductBySlug as getBridalProduct,   getRelatedProducts as getBridalRelated   } from "../data/bridalPlanners";
  import { getProductBySlug as getDailyProduct,    getRelatedProducts as getDailyRelated    } from "../data/dailyPlanners";
  import { getProductBySlug as getProdProduct,     getRelatedProducts as getProdRelated     } from "../data/ProductivityPlanners";
  import { getProductBySlug as getGrtProduct,      getRelatedProducts as getGrtRelated      } from "../data/Gratitudejournals";
  import { getProductBySlug as getTravelProduct,   getRelatedProducts as getTravelRelated   } from "../data/travelPlanners";
  import { getProductBySlug as getWdpProduct,      getRelatedProducts as getWdpRelated      } from "../data/weeklyDeskPlanners";
  import { getProductBySlug as getLnProduct,       getRelatedProducts as getLnRelated       } from "../data/listNotepads";
  import { getProductBySlug as getTwProduct,       getRelatedProducts as getTwRelated       } from "../data/twPlanners";
  import { getProductBySlug as getWellProduct,     getRelatedProducts as getWellRelated     } from "../data/wellnessJournals";
  import { getProductBySlug as getBulletProduct,   getRelatedProducts as getBulletRelated   } from "../data/bulletJournals";
  import { getProductBySlug as getRecipeProduct,   getRelatedProducts as getRecipeRelated   } from "../data/recipeJournals";
  import { getProductBySlug as getNotebookProduct, getRelatedProducts as getNotebookRelated } from "../data/notebooks";
  import { getProductBySlug as getBbProduct,       getRelatedProducts as getBbRelated       } from "../data/boldBright";
  import { getProductBySlug as getCsProduct,       getRelatedProducts as getCsRelated       } from "../data/checksStripes";
  import { getProductBySlug as getFlProduct,       getRelatedProducts as getFlRelated       } from "../data/florals";
  import { getProductBySlug as getPpProduct,       getRelatedProducts as getPpRelated       } from "../data/patternsPrints";
  // import { getProductBySlug as getFatherProduct,   getRelatedProducts as getFatherRelated   }   from "../data/fatherdays";
  import { getProductBySlug as getHnProduct,       getRelatedProducts as getHnRelated       }   from "../data/homenotebook";
  import { getProductBySlug as getSliderProduct,   getRelatedProducts as getSliderRelated   }   from "../data/productSliderData";

  const COLLECTION_MAP = [
    { match:"gift-hampers",        getProduct:getGhProduct,       getRelated:getGhRelated,       backPath:"/gift-hampers",        backLabel:"Gift Hampers",          cardBasePath:"/gift-hampers" },
    { match:"bridal-planner",      getProduct:getBridalProduct,   getRelated:getBridalRelated,   backPath:"/bridal-planner",      backLabel:"Bridal Planners",       cardBasePath:"/bridal-planner" },
    { match:"productivityplanner", getProduct:getProdProduct,     getRelated:getProdRelated,     backPath:"/Productivityplanner", backLabel:"Productivity Planners", cardBasePath:"/productivityplanner" },
    { match:"gratitude-journals",  getProduct:getGrtProduct,      getRelated:getGrtRelated,      backPath:"/gratitude-journals",  backLabel:"Gratitude Journals",    cardBasePath:"/gratitude-journals" },
    { match:"travel-planner",      getProduct:getTravelProduct,   getRelated:getTravelRelated,   backPath:"/travel-planner",      backLabel:"Travel Planners",       cardBasePath:"/travel-planner" },
    { match:"weekly-desk-planner", getProduct:getWdpProduct,      getRelated:getWdpRelated,      backPath:"/weekly-desk-planner", backLabel:"Weekly Desk Planners",  cardBasePath:"/weekly-desk-planner" },
    { match:"list-notepads",       getProduct:getLnProduct,       getRelated:getLnRelated,       backPath:"/list-notepads",       backLabel:"List Notepads",         cardBasePath:"/list-notepads" },
    { match:"twplanner",           getProduct:getTwProduct,       getRelated:getTwRelated,       backPath:"/twplanner",           backLabel:"2026 Planners",         cardBasePath:"/twplanner" },
    { match:"wellness-journals",   getProduct:getWellProduct,     getRelated:getWellRelated,     backPath:"/wellness-journals",   backLabel:"Wellness Journals",     cardBasePath:"/wellness-journals" },
    { match:"bullet-journals",     getProduct:getBulletProduct,   getRelated:getBulletRelated,   backPath:"/bullet-journals",     backLabel:"Bullet Journals",       cardBasePath:"/bullet-journals" },
    { match:"recipe-journals",     getProduct:getRecipeProduct,   getRelated:getRecipeRelated,   backPath:"/recipe-journals",     backLabel:"Recipe Journals",       cardBasePath:"/recipe-journals" },
    { match:"notebooks",           getProduct:getNotebookProduct, getRelated:getNotebookRelated, backPath:"/notebooks",           backLabel:"Notebooks",             cardBasePath:"/notebooks" },
    { match:"bold-bright",         getProduct:getBbProduct,       getRelated:getBbRelated,       backPath:"/bold-bright",         backLabel:"Bold & Bright",         cardBasePath:"/bold-bright" },
    { match:"checks-stripes",      getProduct:getCsProduct,       getRelated:getCsRelated,       backPath:"/checks-stripes",      backLabel:"Checks & Stripes",      cardBasePath:"/checks-stripes" },
    { match:"florals",             getProduct:getFlProduct,       getRelated:getFlRelated,       backPath:"/florals",             backLabel:"Florals",               cardBasePath:"/florals" },
    { match:"patterns-prints",     getProduct:getPpProduct,       getRelated:getPpRelated,       backPath:"/patterns-prints",     backLabel:"Patterns & Prints",     cardBasePath:"/patterns-prints" },
    //  { match:"fatherday", getProduct:getFatherProduct, getRelated:getFatherRelated, backPath:"/fatherday", backLabel:"Father's Day", cardBasePath:"/fatherday" },
    { match:"homenotebook", getProduct:getHnProduct, getRelated:getHnRelated, backPath:"/homenotebook", backLabel:"Notebooks & Journals", cardBasePath:"/homenotebook" },
    { match:"collection-products", getProduct:getSliderProduct, getRelated:getSliderRelated,
    backPath:"/", backLabel:"Our Collections", cardBasePath:"/collection-products" },
    { match:null, getProduct:getDailyProduct, getRelated:getDailyRelated, backPath:"/Dailyplanner", backLabel:"Daily Planners", cardBasePath:"/dailyplanners" },
  ];

  function resolveCollection(pathname) {
    return (
      COLLECTION_MAP.find(c => c.match && pathname.includes(c.match)) ||
      COLLECTION_MAP[COLLECTION_MAP.length - 1]
    );
  }

  function FontImport() {
    return (
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;1,9..144,500&family=DM+Sans:wght@400;500;600;700&display=swap');
      .og-display{font-family:'Fraunces',serif} .og-body{font-family:'DM Sans',sans-serif}`}</style>
    );
  }

  function Stars({ value }) {
    const v = Math.round(parseFloat(value));
    return (
      <div className="flex gap-0.5">
        {[1,2,3,4,5].map(n => (
          <Star key={n} size={14} className={n <= v ? "fill-[#1A1A1A] text-[#1A1A1A]" : "fill-none text-[#1A1A1A]/30"}/>
        ))}
      </div>
    );
  }

  function addBusinessDays(start, days) {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString("en-IN", { month:"short", day:"numeric" });
  }

  // ── Gallery ───────────────────────────────────────────────────────────────────

  function Gallery({ images, productName, personalName, font, nameColor, namePosition, nameFontSize, rotation }) {
    const [active, setActive] = useState(0);
    return (
      <div className="flex gap-2 sm:gap-3 w-full">
        <div className="flex flex-col gap-1.5 sm:gap-2 overflow-y-auto" style={{ maxHeight:420 }}>
          {images.map((img, i) => (
            <button key={i} onClick={() => setActive(i)}
              className={`flex-shrink-0 w-[46px] h-[56px] sm:w-[60px] sm:h-[72px] rounded-md overflow-hidden border-2 transition-all ${
                active===i ? "border-[#1A1A1A] opacity-100" : "border-gray-200 opacity-60 hover:opacity-100"
              }`}>
              <img src={img} alt={`view ${i+1}`} className="w-full h-full object-cover"/>
            </button>
          ))}
        </div>
        <div className="flex-1 relative rounded-xl overflow-hidden bg-white">
          <span className="absolute left-2.5 sm:left-3 top-2.5 sm:top-3 z-10 flex items-center gap-1.5 rounded-full bg-white px-2.5 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-[11px] font-semibold shadow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-3.5 h-3.5">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
            Look Inside
          </span>
          <div className="aspect-[4/5] relative">
          <img src={images[active]} alt={productName} className="w-full h-full object-cover transition-opacity duration-300"/>
            {personalName && (
              <div
                className="absolute pointer-events-none z-10 text-center"
                style={{
                  bottom: namePosition?.bottom || "20%",
                  left: namePosition?.left || "50%",
                  transform: `translateX(-50%) rotate(${rotation || 0}deg)`,
                  width: "max-content",
                  maxWidth: "90%",
                }}
              >
                <p
                  className="leading-tight break-words whitespace-nowrap"
                  style={{
                    fontFamily: font || "'Dancing Script', cursive",
                    color: nameColor || "#1A1A1A",
                    fontSize: nameFontSize || "22px",
                  }}
                >
                  {personalName}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }


  function RelatedCard({ product, basePath }) {
    return (
      <Link to={`${basePath}/${product.id}`} className="group flex flex-col">
        <div className="aspect-[4/5] overflow-hidden rounded-md bg-white">
          <img src={product.image} alt={product.name} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"/>
        </div>
        <div className="mt-2.5 sm:mt-3 flex flex-col gap-0.5">
          <h3 className="text-[13px] sm:text-sm font-bold leading-snug">{product.name}</h3>
          <p className="text-[11px] sm:text-xs text-[#6B655C]">{product.subtitle}</p>
          <div className="mt-1 flex items-baseline gap-1.5">
            <p className="text-[13px] sm:text-sm font-bold">Rs. {product.price.toLocaleString("en-IN")}</p>
            {product.comparePrice && (
              <p className="rounded-sm bg-[#fce954] px-1 text-[11px] sm:text-xs font-bold text-[#1A1A1A]/70 line-through">
                Rs. {product.comparePrice.toLocaleString("en-IN")}
              </p>
            )}
          </div>
        </div>
      </Link>
    );
  }

  // ── Paper Type Dropdown ───────────────────────────────────────────────────────
  const PAPER_TYPES = ["Lined", "Dotted/Bullet", "Plain"];
  function PaperTypeDropdown({ value, onChange }) {
    const [open, setOpen] = useState(false);
    return (
      <div className="mt-5 relative">
        <p className="mb-2 text-sm font-semibold">Paper Type</p>
        <button onClick={() => setOpen(o => !o)}
          className="w-full flex items-center justify-between border border-gray-300 rounded-md px-4 py-3 text-sm font-medium hover:border-gray-500 bg-white">
          <span>{value}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`}>
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
        {open && (
          <div className="absolute top-full left-0 right-0 z-20 bg-white border border-gray-200 rounded-md shadow-lg mt-1 overflow-hidden">
            {PAPER_TYPES.map(type => (
              <button key={type} onClick={() => { onChange(type); setOpen(false); }}
                className={`w-full text-left px-4 py-3 text-sm transition-colors ${value===type ? "bg-gray-50 font-semibold" : "text-gray-700 hover:bg-gray-50"}`}>
                {type}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Cover Type Radio ──────────────────────────────────────────────────────────
  function CoverTypeRadio({ value, onChange }) {
    return (
      <div className="mt-5">
        {["Classic hardcover", "Spiral bound hardcover"].map(type => (
          <label key={type} className="flex items-center gap-3 py-2 cursor-pointer">
            <div onClick={() => onChange(type)}
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${value===type ? "border-[#1A1A1A]" : "border-gray-300"}`}>
              {value===type && <div className="w-2.5 h-2.5 rounded-full bg-[#1A1A1A]"/>}
            </div>
            <span className="text-sm font-medium">{type}</span>
          </label>
        ))}
      </div>
    );
  }

  // ── Instagram Section ─────────────────────────────────────────────────────────
  const UGC_IMAGES = [
    "https://oddgiraffe.com/cdn/shop/files/1760_1363247459750104181_n_1_1.jpg?v=1654772067",
    "https://oddgiraffe.com/cdn/shop/files/224240788_943586059552275_596654800752328921_n_1.jpg?v=1654772077",
    "https://oddgiraffe.com/cdn/shop/files/72153039_159773952004760_1363247459750104181_n_1.jpg?v=1654772053",
    "https://oddgiraffe.com/cdn/shop/files/Asset_44.webp?v=1688817918",
  ];
  function InstagramSection() {
    return (
      <section className="bg-white py-10 sm:py-16 px-4">
        <div className="mx-auto max-w-5xl text-center">
          <h2 className="og-display text-2xl sm:text-3xl md:text-4xl text-[#1A1A1A] mb-2.5 sm:mb-3 leading-snug px-2">Inspiring quotes and inspired customer stories.</h2>
          <p className="og-body text-gray-500 text-[13.5px] sm:text-[15px] mb-7 sm:mb-10">Use #aishcraftgang for a chance to get featured.</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 sm:gap-3">
            {UGC_IMAGES.map((src, i) => (
              <div key={i} className="aspect-square overflow-hidden rounded-lg">
                <img src={src} alt={`customer story ${i+1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"/>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  const REVIEW_QUOTES = [
    { quote:"This planner makes me so organised and looks so pretty on my desk! My fav undated planner yet!", name:"AYUSH MISHRA" },
    { quote:"The quality blew me away. Every page is thoughtfully designed — exactly what I needed.", name:"RAHUL MEHTA" },
    { quote:"Gifted this to my best friend and she absolutely loved it. The packaging was stunning too!", name:"ANANYA NAIR" },
  ];

  function ReviewQuoteSection() {
    const [idx, setIdx] = useState(0);
    const q = REVIEW_QUOTES[idx];
    return (
      <section className="bg-[#E8E0F0] py-12 sm:py-20 px-4">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="og-display text-2xl sm:text-3xl md:text-4xl text-[#1A1A1A] mb-3 sm:mb-4 leading-snug px-1">
            Here's what our other customers have to say
          </h2>
          <Link to="#" className="text-sm font-semibold underline underline-offset-4 text-[#1A1A1A] mb-8 sm:mb-12 inline-block">
            Read all of our reviews
          </Link>
          <blockquote className="og-display text-xl sm:text-2xl md:text-3xl italic text-[#1A1A1A] leading-relaxed mt-6 sm:mt-8 mb-5 sm:mb-6 px-1">
            "{q.quote}"
          </blockquote>
          <p className="text-sm font-bold tracking-widest text-gray-500">– {q.name}</p>
          <div className="flex items-center justify-center gap-2 mt-7 sm:mt-8">
            {REVIEW_QUOTES.map((_, i) => (
              <button key={i} onClick={() => setIdx(i)}
                className={`w-2 h-2 rounded-full transition-all ${i===idx ? "bg-[#1A1A1A] scale-125" : "bg-gray-400"}`}/>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // ── Main ──────────────────────────────────────────────────────────────────────
  export default function ProductPage() {
    const { slug }      = useParams();
    const navigate      = useNavigate();
    const { pathname }  = useLocation();
    const { addToCart } = useCart();

    const { getProduct, getRelated, backPath, backLabel, cardBasePath } = resolveCollection(pathname);

    // product: undefined = still loading, null = not found, object = loaded
    const [product, setProduct] = useState(undefined);
    const [related, setRelated] = useState([]);

    const [colorIdx, setColorIdx]               = useState(0);
    const [openSection, setOpenSection]         = useState("");
    const [paperType, setPaperType]             = useState("Lined");
    const [coverType, setCoverType]             = useState("Classic hardcover");
    const [firstName, setFirstName]             = useState("");
    const [lastName,  setLastName]              = useState("");
    const [previewName, setPreviewName]         = useState("");

    const isNotebook = pathname.includes("notebooks") || pathname.includes("bold-bright") ||
                      pathname.includes("checks-stripes") || pathname.includes("florals") ||
                      pathname.includes("patterns-prints");
    const isPatternsPrints = pathname.includes("patterns-prints");

    // Load product + related — works whether getProduct/getRelated are sync (old
    // hardcoded categories) or async (backend-connected categories like Daily Planner)
    useEffect(() => {
      let cancelled = false;
      setProduct(undefined);
      setRelated([]);

      Promise.resolve(getProduct(slug))
        .then(async (p) => {
          if (cancelled) return;
          if (!p) { setProduct(null); return; }
          setProduct(p);
          const rel = await Promise.resolve(getRelated(p.id, 4));
          if (!cancelled) setRelated(rel || []);
        })
        .catch(() => {
          if (!cancelled) setProduct(null);
        });

      return () => { cancelled = true; };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug, pathname]);

    useEffect(() => {
      window.scrollTo({ top:0, behavior:"smooth" });
      setColorIdx(0); setPaperType("Lined"); setCoverType("Classic hardcover");
      setFirstName(""); setLastName("");
    }, [slug]);

    const handlePersonaliseAddToCart = ({ name }) => {
      addToCart({
        ...product,
        personalisedName: name,
        paperType: isNotebook ? paperType : undefined,
      }, colorIdx);
    };

    // ── Still loading ──
    if (product === undefined) {
      return (
        <div className="og-body grid min-h-screen place-items-center bg-white px-6 text-center text-[#1A1A1A]">
          <FontImport/>
          <p className="text-gray-500">Loading...</p>
        </div>
      );
    }

    // ── Not found ──
    if (!product) {
      return (
        <div className="og-body grid min-h-screen place-items-center bg-white px-6 text-center text-[#1A1A1A]">
          <FontImport/>
          <div>
            <h1 className="og-display text-3xl">We couldn't find that planner</h1>
            <p className="mt-2 text-[#6B655C]">It may have sold out or the link is off.</p>
            <button onClick={() => navigate(backPath)} className="mt-6 rounded-full bg-[#1A1A1A] px-6 py-2.5 text-sm font-semibold text-white">
              Back to {backLabel}
            </button>
          </div>
        </div>
      );
    }

    const galleryImages = product?.images?.length
      ? product.images
      : [product.image, product.image, product.image, product.image];

    const shipStart = addBusinessDays(new Date(), 6);
    const shipEnd   = addBusinessDays(new Date(), 8);

    return (
      <div className="og-body min-h-screen bg-white text-[#1A1A1A]">
        <FontImport/>

        {/* Announcement */}
        <div className="bg-[#FFEB3B] px-4 py-2.5 sm:py-3 text-center">
          <p className="og-display text-[13px] italic sm:text-[14px] md:text-base font-medium text-black">Get 20% Off the new 2026 Planners!</p>
          <p className="text-[10.5px] sm:text-[11px] text-black/80 font-medium mt-0.5">300+ designs to personalise • No code required</p>
        </div>

        {/* Breadcrumb */}
        <div className="mx-auto max-w-7xl px-4 pt-4 sm:pt-5 sm:px-6">
          <nav className="og-body flex flex-wrap items-center gap-1.5 text-xs text-[#6B655C]">
            <Link to="/" className="hover:text-[#1A1A1A]">Home</Link>
            <span>/</span>
            <Link to={backPath} className="hover:text-[#1A1A1A]">{backLabel}</Link>
            <span>/</span>
            <span className="text-[#1A1A1A]">{product.name}</span>
          </nav>
        </div>

        {/* Product main */}
        <main className="mx-auto grid max-w-7xl gap-7 sm:gap-10 px-4 py-6 sm:py-8 sm:px-6 lg:grid-cols-2 lg:gap-16">
          <div className="lg:sticky lg:top-4 lg:self-start">
  <Gallery
    images={galleryImages}
    productName={product.name}
    personalName={isPatternsPrints ? [firstName, lastName].filter(Boolean).join(" ") : previewName}
    font={product.font}
    nameColor={product.nameColor}
    namePosition={product.namePosition}
    nameFontSize={product.nameFontSize}
    rotation={product.rotation}
  />
          </div>

          <div className="og-body">
            <p className="text-xs text-[#6B655C]">{product.subtitle}</p>
            <h1 className="og-display mt-1 text-[26px] sm:text-4xl leading-tight">{product.name}</h1>

            {/* Aishcraft brand description — sits between the title and the rating */}
            <p className="mt-2 text-[13px] sm:text-sm leading-relaxed text-[#6B655C] max-w-prose">
              At Aishcraft, every piece is designed to bring a little more joy to your everyday.
              We blend thoughtful design with premium materials to create products that feel personal.
              Each item is crafted with care and made to order, just for you.
              Small details, big heart — that's the Aishcraft promise.
            </p>

            <div className="mt-3 flex items-center gap-2">
              <Stars value={product.rating}/>
    {product.reviews > 0 && (
      <span className="text-sm text-[#6B655C]">{product.reviews} reviews</span>
    )}
  </div>
            <div className="mt-4 flex items-baseline gap-2">
              <span className="text-xl sm:text-2xl font-semibold">Rs. {(product.price || 0).toLocaleString("en-IN")}</span>
              {product.comparePrice && (
                <span className="rounded-sm bg-[#fce954] px-1 text-sm sm:text-base text-[#1A1A1A]/70 line-through">
                  Rs. {product.comparePrice.toLocaleString("en-IN")}
                </span>
              )}
            </div>
            <p className="mt-4 max-w-prose text-[14px] sm:text-[15px] leading-relaxed text-[#3F3A33]">{product.description}</p>

            {/* Color swatches */}
            {/* {product.swatches?.length > 0 && (
              <div className="mt-6">
                <p className="mb-2 text-sm font-semibold">Color</p>
                <div className="flex flex-wrap gap-2">
                  {product.swatches.map((c, i) => (
                    <button key={c+i} onClick={() => setColorIdx(i)} aria-label={`Shade ${i+1}`}
                      className={`h-8 w-8 sm:h-9 sm:w-9 rounded-full border-2 transition-all ${colorIdx===i ? "border-[#1A1A1A] scale-110" : "border-transparent"}`}
                      style={{ backgroundColor: c }}/>
                  ))}
                </div>
              </div>
            )} */}

            {isPatternsPrints && <CoverTypeRadio value={coverType} onChange={setCoverType}/>}
            {isNotebook && <PaperTypeDropdown value={paperType} onChange={setPaperType}/>}

            {isPatternsPrints && (
              <div className="mt-5 flex flex-col gap-3">
                <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First name"
                  className="w-full border border-gray-300 rounded-md px-4 py-3 text-sm focus:border-[#1A1A1A] focus:outline-none"/>
                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last name"
                  className="w-full border border-gray-300 rounded-md px-4 py-3 text-sm focus:border-[#1A1A1A] focus:outline-none"/>
              </div>
            )}

          {/* CTA */}

  <div className="mt-6 sm:mt-7 flex flex-col gap-3 sm:flex-row">
    {isPatternsPrints ? (
      <button
        onClick={() => addToCart({
          ...product,
          personalisedName: [firstName, lastName].filter(Boolean).join(" "),
          coverType,
        }, colorIdx)}
        className="rounded-md bg-[#1A1A1A] px-8 py-2.5 text-sm font-semibold text-white hover:bg-[#333] transition-colors w-fit">
        Add to bag
      </button>
    ) : product.isPersonalizable ? (
      <PersonalisePanel onAddToCart={handlePersonaliseAddToCart} onNameChange={setPreviewName}/>
    ) : (
      <button
        onClick={() => addToCart({ ...product }, colorIdx)}
        className="rounded-md bg-[#1A1A1A] px-8 py-2.5 text-sm font-semibold text-white hover:bg-[#333] transition-colors w-fit">
        Add to bag
      </button>
    )}
  </div>

            {/* Delivery */}
            <div className="mt-6 sm:mt-7 rounded-md border border-[#1A1A1A]/10 p-3.5 sm:p-4">
              <p className="text-sm font-semibold">Delivery</p>
              <p className="mt-1 text-sm text-[#C1432B]">Ships between – {fmt(shipStart)} and {fmt(shipEnd)}</p>
              <p className="mt-2 text-xs leading-relaxed text-[#6B655C]">
                Every product is made to order with care. Orders are typically shipped within 6 working days,
                excluding weekends. Once shipped, delivery usually takes 2–3 days.
              </p>
            </div>

            {/* Product Highlights */}
            {product.bullets?.length > 0 && (
              <div className="mt-6 sm:mt-7 rounded-md border border-[#1A1A1A]/10 p-4 sm:p-5">
                <p className="text-sm font-bold mb-3">Product Highlights</p>
                <ul className="flex flex-col gap-2">
                  {product.bullets.map(b => (
                    <li key={b} className="flex items-start gap-2 text-sm text-[#3F3A33]">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#1A1A1A] flex-shrink-0"/>
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Accordion */}
            <div className="mt-6 sm:mt-7 divide-y divide-[#1A1A1A]/10 border-y border-[#1A1A1A]/10">
              {[
                { id:"description", label:"What's inside" },
                { id:"specs",       label:"Specifications" },
                { id:"shipping",    label:"Shipping & Returns" },
              ].map(s => (
                <div key={s.id}>
                  <button onClick={() => setOpenSection(openSection===s.id ? "" : s.id)}
                    className="flex w-full items-center justify-between py-4 text-left text-sm font-semibold">
                    {s.label}
                    <span className="og-display text-lg">{openSection===s.id ? "–" : "+"}</span>
                  </button>
                  {openSection===s.id && (
                    <div className="pb-4 text-sm leading-relaxed text-[#3F3A33]">
                      {s.id==="description" && (
                        product.bullets?.length > 0
                          ? <ul className="list-disc space-y-1.5 pl-5">{product.bullets.map(b => <li key={b}>{b}</li>)}</ul>
                          : <p>No additional details available.</p>
                      )}
                      {s.id==="specs"    && <p>Hardbound, A5 size (14.8 × 21cm), 192 pages, 160 GSM paper, elastic closure.</p>}
                      {s.id==="shipping" && <p>Made to order. Free returns within 7 days for an unused, unpersonalised product.</p>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </main>

      

        <InstagramSection/>
        <ReviewQuoteSection/> 
        {/* <FlickThroughSection collectionLabel={backLabel} productName={product.name}/> */}
        <ReviewSection productSlug={slug}/>
      </div>
    );
  }